import server$ from "solid-start/server";
import axios from "axios";
import generatePayload from "~/utils/generatePayload";
import fetchRpcUrl from "~/utils/fetchRpcUrl";
import { fetchPool } from "~/utils/fetchPool";

const { rpc_url, fallback } = fetchRpcUrl();

export const getBlockCount = server$(async () => {
  try {
    const res = await axios.post(
      rpc_url,
      generatePayload("getblockcount", "verusidsdotcom", [])
    );
    return res.data.result;
  } catch (e) {
    if (fallback) {
      const res = await axios.post(
        fallback,
        generatePayload("getblockcount", "verusidsdotcom", [])
      );
      return res.data.result;
    }
  }
});

export const getUpdateTime = server$(async () => {
  const pool = await fetchPool();
  const client = await pool.connect();
  const updateTime = await client.query("SELECT * FROM stats");
  client.release();
  return updateTime.rows;
});
